export default __webpack_public_path__ + "static/media/logo_non_noti.40aefcfc.svg";